import React, { useLayoutEffect, useRef } from "react";
import _ from "lodash";
import { Avatar } from "@toddle-edu/ds-web";
import classes from "./PlaybackContent.scss";
import classNames from "classnames";

const getTextPartClass = ({ type = "" }) => {
  const typeClassMap = {
    insert: classes.insertedTextContent,
    paste: classes.pastedTextContent,
    delete: classes.deletedTextContent,
  };

  return classNames(classes.textContent, typeClassMap[type]);
};

const getCleanText = (text = "") => {
  // eslint-disable-next-line no-control-regex, sonarjs/no-control-regex
  return text.replace(/[\x00-\x08\x0B-\x1F]/g, " ");
};

const PlaybackContent = ({
  currentStep,
  finalContent,
  documentParts,
  userMap,
  userId,
}) => {
  const partRefs = useRef([]);

  useLayoutEffect(() => {
    const index = _.findIndex(documentParts, p =>
      _.includes(["insert", "paste", "delete"], p.type)
    );
    const el = partRefs.current[index];
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [documentParts]);

  if (currentStep === 0) {
    return (
      <div
        className={classNames(
          "text-body",
          classes.content,
          classes.textContent
        )}
      >
        {getCleanText(finalContent)}
      </div>
    );
  }
  return (
    <div className={classNames("text-body", classes.content)}>
      {_.map(documentParts, (part, i) => (
        <span
          key={i}
          ref={el => {
            if (el) partRefs.current[i] = el;
          }}
          className={getTextPartClass(part)}
        >
          {!_.isEmpty(userMap) &&
            part?.type &&
            userId &&
            _.has(userMap, userId) && (
              <div className={classes.userContainer}>
                <Avatar
                  dsVersion="2.0"
                  size="xxx-small"
                  src={`https:${userMap[userId]?.photo}`}
                />
                <div className={"text-body-s"}>{userMap[userId]?.name}</div>
              </div>
            )}
          {getCleanText(part.text || " ")}
        </span>
      ))}
    </div>
  );
};

export default PlaybackContent;
